import React from 'react'
import { NextSeo, BreadcrumbJsonLd } from 'next-seo'
import { withRouter } from 'next/router'
import { inject, observer } from 'mobx-react'
import Layout from '~/components/traffic/lookup/Layout'
import Wisepops from '~/components/_integrations/Wisepops'
import Sumo from '~/components/_integrations/Sumo'
import { LOOKUP_SEO } from '~/utilities/seo-lookup'

@inject(all => ({
  setFetcherState: all.store.trafficLookup.setFetcherState,
  setFetcherName: all.store.trafficLookup.setFetcherName,
  setIsStateAffiliatedWithWinitLaw:
    all.store.trafficLookup.setIsStateAffiliatedWithWinitLaw,
}))
@observer
class TrafficLookupPage extends React.Component {
  static async getInitialProps(ctx) {
    ctx.store.trafficLookup.setFetcherState('NY')
    ctx.store.trafficLookup.setFetcherName('NY')
    ctx.store.trafficLookup.setUseNYDMVForm(true)
    ctx.store.trafficLookup.prepopulateUserInfo()
    await ctx.store.trafficLookup.loadTrafficStates()
    ctx.store.trafficLookup.restoreLookupFormFromStorage()
    ctx.store.trafficLookup.setIsStateAffiliatedWithWinitLaw('NY')
    return { query: ctx.query }
  }

  componentDidMount() {
    this.scrollUp()
  }

  scrollUp = () => {
    if (process.browser) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  render() {
    const seo = LOOKUP_SEO.NY
    return (
      <>
        <NextSeo
          title={seo.title}
          description={seo.description}
          canonical={seo.canonical}
          openGraph={{
            title: seo.title,
            description: seo.description,
            url: seo.canonical,
          }}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            { position: 1, name: 'Home', item: 'https://www.trafficviolations.info' },
            { position: 2, name: 'Traffic Ticket Lookup', item: 'https://www.trafficviolations.info/traffic/lookup' },
          ]}
        />
        <Layout />
        <Wisepops />
        <Sumo />
      </>
    )
  }
}

export default withRouter(TrafficLookupPage)
